import JSONModel from "sap/ui/model/json/JSONModel";
import BaseController from "../controller/BaseController";
import { EnvironmentService } from "../service/Environment.service";
import MessageBox from "sap/m/MessageBox";
import Button, { Button$PressEvent } from "sap/m/Button";
import ObjectPageSubSection from "sap/uxap/ObjectPageSubSection";
import { ObjectPageSubSectionMode } from "sap/uxap/library";
import { ErrorHandler } from "../service/ErrorHandler.service";
import { ListBase$ItemPressEvent, ListBase$SwipeEvent } from "sap/m/ListBase";
import { Belegposition } from "../model/models";

/**
 * @namespace com.unitrade.crm.blocks
 */
export default class BelegPositionenBlock extends BaseController {
  onInit(): void {
    this.setModel(new JSONModel());
    this.setModel(new JSONModel(), "meta");
    this.getView().attachModelContextChange(null, this.onModelContextChange);
  }

  onExit(): void {
    this.getView().detachModelContextChange(null, this.onModelContextChange);
  }

  handleExpandCollapsePress = (oEvent: Button$PressEvent) => {
    const parentBlock = (this as any).oParentBlock as ObjectPageSubSection;
    const sNewMode = parentBlock.getMode() === ObjectPageSubSectionMode.Collapsed ? ObjectPageSubSectionMode.Expanded : ObjectPageSubSectionMode.Collapsed;
    parentBlock.setMode(sNewMode);
  };

  async onModelContextChange(oEvent: Event): Promise<void> {
    const oBelegKopf = this.getModel("belegkopf");
    const sBelegart: string = oBelegKopf.getProperty("/art");
    const nBelegnummer: number = oBelegKopf.getProperty("/id");
    const oModel = this.getModel() as JSONModel;
    const oMetaModel = this.getModel("meta") as JSONModel;
    try {
      oMetaModel.setProperty("/busy", true);
      await oModel.loadData(`${EnvironmentService.getBaseUrl()}/beleg/${sBelegart}/${nBelegnummer}/positionen`);
    } catch (ex: any) {
      ErrorHandler.handleError(ex, { message: "Fehler beim Laden der Belegpositionen" });
    } finally {
      oMetaModel.setProperty("/busy", false);
    }
  }

  public onPositionPress = async (oEvent: ListBase$ItemPressEvent) => {
    const oItem = oEvent.getSource();
    const oBelegpos = oItem.getBindingContext().getObject() as Belegposition;
    //this.redirectToBelegposition(oBelegpos.art, oBelegpos.belegnummer, oBelegpos.nummer);
    this.redirectToArtikel(oBelegpos.artikelId);
  };

  public handleSwipe = async (oEvent: ListBase$SwipeEvent) => {
    const oSwipeDirection = oEvent.getParameter("swipeDirection");
    const oSwipeContent = oEvent.getParameter("swipeContent") as Button;

    if (oSwipeDirection === "BeginToEnd") {
      oSwipeContent.setText("Bearbeiten");
    } else {
      oSwipeContent.setText("Löschen");
    }
  };

  private redirectToArtikel = async (artid: number) => {
    this.getOwnerComponent().getRouter().navTo("articleDetails", { idPath: artid });
  };

  private redirectToBelegposition = async (belegart: string, belegNr: number, posId: number) => {
    this.getOwnerComponent().getRouter().navTo("belegPositionDetails", { artPath: belegart, idPath: belegNr, posPath: posId });
  };
}
